import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { GraphQLMutate } from '../utils/methods/graphql.mutate';

@Injectable()
export class UpdateBatchMutation extends GraphQLMutate {
	override command: DocumentNode = gql`
		mutation UpdateBatch($input: UpdateBatchInput!) {
			updateBatch(input: $input) {
				id
				alias
				name
				status
				productionStart
				errors {
					terminalId
					type
					message
				}
			}
		}
	`;
}
